import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Warning, PaperPlaneTilt, ArrowSquareOut } from "@phosphor-icons/react";
import { fmtDate } from "../../lib/dateUtil";

/* Amber banner: the job changed after its works order was sent — one-click re-issue to the supplier */
export function WoStaleBanner({ flag, onReissued, className = "", testid = "wo-stale-banner" }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!flag?.wo_id) return null;
  const reissue = async () => {
    setBusy(true);
    try {
      const { data } = await API.post(`/works-orders/${flag.wo_id}/reissue`);
      toast.success(`${flag.wo_number} re-issued — ${data.message}`);
      onReissued?.(data);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to re-issue works order"); }
    finally { setBusy(false); }
  };
  const what = (flag.changed_fields || []).join(", ") || "job details";
  return (
    <div className={`rounded-lg border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30 px-4 py-3 flex items-start gap-3 ${className}`} data-testid={testid}>
      <Warning size={20} weight="fill" className="text-amber-500 shrink-0 mt-0.5" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-amber-900 dark:text-amber-200">Works order {flag.wo_number} is out of date</p>
        <p className="text-xs text-amber-800/90 dark:text-amber-300/90 mt-0.5" data-testid={`${testid}-detail`}>
          The {what} changed on {fmtDate(flag.changed_at)}{flag.changed_by ? ` (${flag.changed_by})` : ""} after the WO was sent to the supplier. Re-issue it so they work from the latest version.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button size="sm" variant="outline" className="h-8 border-amber-400 text-amber-900 dark:text-amber-200 hover:bg-amber-100" onClick={() => navigate(`/work-orders?open=${flag.wo_id}`)} data-testid={`${testid}-view`}>
          <ArrowSquareOut size={14} className="mr-1" /> View WO
        </Button>
        <Button size="sm" className="h-8 bg-amber-600 hover:bg-amber-700 text-white" disabled={busy} onClick={reissue} data-testid={`${testid}-reissue`}>
          <PaperPlaneTilt size={14} className="mr-1" /> {busy ? "Re-issuing…" : "Re-issue to supplier"}
        </Button>
      </div>
    </div>
  );
}

export default WoStaleBanner;
